import React, { useContext, useMemo, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { BoxProps } from '@chakra-ui/react'

import { DateTimePickerContext } from '../../helpers'
import { VisibleSectionEnum } from '../../interfaces'

import { Hour } from './components/Hour'
import { TimePickerGrid, TimePickerWrapper } from './styles'

export const TimePicker = ({ ...boxProps }: BoxProps): JSX.Element => {
  const { dateTimeState } = useContext(DateTimePickerContext)
  const [defaultVisible] = useState<boolean>(
    Boolean(dateTimeState.props.defaultDate && dateTimeState.props.defaultTime),
  )

  const nodeRef = useRef(null)

  const hoursArray = useMemo(() => [...Array(24)], [])

  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={dateTimeState.isExpanded && dateTimeState.visibleSection === VisibleSectionEnum.TIME}
      classNames="fade"
      timeout={300}
      unmountOnExit
      mountOnEnter
    >
      <TimePickerWrapper {...boxProps} defaultVisible={defaultVisible} ref={nodeRef}>
        <TimePickerGrid templateColumns="repeat(4, 1fr)" gap="4px">
          {hoursArray.map((_, index) => (
            <Hour key={`${dateTimeState.value.month}-${index}`} index={index} />
          ))}
        </TimePickerGrid>
      </TimePickerWrapper>
    </CSSTransition>
  )
}
